import { createStore, createHook, createActionsHook } from 'react-sweet-state';
import type {
	BoundActions,
	HookActionsFunction,
	HookFunction,
	Store,
	StoreActionApi,
} from 'react-sweet-state';

import type { JSONDocNode } from '@atlaskit/editor-json-transformer/types';

export type UpdateDocumentState = {
	updateDocumentFn: (doc: JSONDocNode) => void;
};

export const initialState: UpdateDocumentState = {
	updateDocumentFn: () => {},
};

export const actions = {
	setUpdateDocumentFn:
		(newUpdateDocumentFn: (doc: JSONDocNode) => void) =>
		({ setState }: StoreActionApi<UpdateDocumentState>): void => {
			setState({
				updateDocumentFn: newUpdateDocumentFn,
			});
		},
};

export const UpdateDocumentStore: Store<
	UpdateDocumentState,
	{
		setUpdateDocumentFn: (
			newUpdateDocumentFn: (doc: JSONDocNode) => void,
		) => ({ setState }: StoreActionApi<UpdateDocumentState>) => void;
	}
> = createStore({
	initialState,
	actions,
	name: 'UpdateDocumentStore',
});

export const useUpdateDocument: HookFunction<
	UpdateDocumentState,
	BoundActions<
		UpdateDocumentState,
		{
			setUpdateDocumentFn: (
				newUpdateDocumentFn: (doc: JSONDocNode) => void,
			) => ({ setState }: StoreActionApi<UpdateDocumentState>) => void;
		}
	>,
	void
> = createHook(UpdateDocumentStore);
export const useUpdateDocumentActions: HookActionsFunction<
	BoundActions<
		UpdateDocumentState,
		{
			setUpdateDocumentFn: (
				newUpdateDocumentFn: (doc: JSONDocNode) => void,
			) => ({ setState }: StoreActionApi<UpdateDocumentState>) => void;
		}
	>
> = createActionsHook(UpdateDocumentStore);
